import {useConfigurationDataStore} from '~/store/configuration-data'
import {CONFIGURATION_KEYS} from 'assets/js/constants'

export const useTariffHelper = () => {
  const {configurations} = storeToRefs(useConfigurationDataStore())

  const isTariffEnabled = computed(() => {
    let tariffConfig: any = configurations?.value?.find((config: any) => config.key === CONFIGURATION_KEYS.US_TARIFF_FEATURE_ENABLED)
    return tariffConfig?.value === 'True'
  })

  const isTariffDisclaimerEnabled = computed(() => {
    let tariffDisclaimerConfig: any = configurations?.value?.find((config: any) => config.key === CONFIGURATION_KEYS.TARIFF_DISCLAIMER_ENABLED)
    return tariffDisclaimerConfig?.value === 'True'
  })

  return {
    isTariffEnabled,
    isTariffDisclaimerEnabled
  }
}
